import React, { useEffect, useState } from 'react';
import { XIcon, CheckCircle2Icon } from 'lucide-react';
const buyers = [{
  name: 'María',
  city: 'Ciudad de México, MX'
}, {
  name: 'Carmen',
  city: 'Bogotá, CO'
}, {
  name: 'Lucía',
  city: 'Santiago, CL'
}, {
  name: 'Rosa',
  city: 'Lima, PE'
}, {
  name: 'Elena',
  city: 'Buenos Aires, AR'
}, {
  name: 'Ana',
  city: 'Medellín, CO'
}, {
  name: 'Marta',
  city: 'Guadalajara, MX'
}, {
  name: 'Patricia',
  city: 'Quito, EC'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1;
    setCurrentBuyer(randomBuyer);
    setTimeAgo(randomTime);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        showNextBuyer();
      }, Math.random() * 8000 + 12000);
    }, 6000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 z-50 max-w-[300px] mx-auto sm:mx-0" data-id="element-155">
      <div className="bg-white border-2 border-brand-lime rounded-lg p-3 shadow-xl relative" data-id="element-156">
        <button onClick={() => setIsVisible(false)} className="absolute top-1 right-1 text-brand-muted hover:text-brand-text" aria-label="Cerrar" data-id="element-157">
          <XIcon className="w-4 h-4" data-id="element-158" />
        </button>

        <div className="flex items-center gap-3 pr-4" data-id="element-159">
          <div className="w-10 h-10 rounded-full bg-brand-forest text-white flex items-center justify-center font-bold text-lg shrink-0" data-id="element-160">
            {currentBuyer.name.charAt(0)}
          </div>
          <div className="min-w-0" data-id="element-161">
            <p className="text-xs text-brand-text leading-tight" data-id="element-162">
              <span className="font-bold" data-id="element-163">{currentBuyer.name}</span> de{' '}
              <span className="font-semibold" data-id="element-164">{currentBuyer.city}</span> compró
              el Protocolo
            </p>
            <div className="flex items-center gap-1 mt-1" data-id="element-165">
              <CheckCircle2Icon className="w-3 h-3 text-brand-lime" data-id="element-166" />
              <span className="text-[10px] text-brand-forest font-bold" data-id="element-167">
                Compra verificada
              </span>
              <span className="text-[10px] text-brand-muted" data-id="element-168">
                · hace {timeAgo} min
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}